{
  "title": "Calendar",
  "description": "Scheduled lessons, week by week.",
  "classFilter": "Class",
  "allClasses": "All classes",
  "previousWeek": "Previous week",
  "nextWeek": "Next week",
  "thisWeek": "This week",
  "minutes_one": "{{count}} min",
  "minutes_other": "{{count}} min",
  "empty": {
    "title": "Nothing scheduled this week",
    "staffText": "Schedule a lesson from its own page and it shows up on this agenda.",
    "readerText": "Lessons your teachers schedule for your classes appear here.",
    "action": "Go to courses",
    "filterTitle": "Nothing for this class this week",
    "filterText": "This week has lessons, but none for the class you filtered to.",
    "clearFilter": "Show all classes"
  },
  "upcoming": {
    "title": "Upcoming lessons",
    "openCalendar": "Open calendar",
    "empty": "No lessons scheduled for the next 7 days."
  },
  "reschedule": {
    "button": "Reschedule",
    "title": "Reschedule lesson",
    "description": "{{lesson}} — {{class}}. Pick a new time or duration.",
    "startsAt": "Starts at",
    "duration": "Duration (minutes)",
    "submit": "Save",
    "success": "Lesson rescheduled"
  },
  "unschedule": {
    "button": "Unschedule",
    "title": "Remove {{lesson}} from the calendar?",
    "description": "The lesson itself stays — only this calendar slot is removed.",
    "success": "Lesson unscheduled"
  }
}
